const BLAZE_DEBUG = 'blaze_debug';
const setBlazeDebug = setIsDebugMode => {
  if (!window.blaze) {
    window.blaze = {
      debug: () => {
        const {
          localStorage
        } = window;
        if (JSON.parse(localStorage.getItem(BLAZE_DEBUG))) {
          localStorage.removeItem(BLAZE_DEBUG);
          setIsDebugMode(false);
          return;
        }
        localStorage.setItem(BLAZE_DEBUG, true);
        setIsDebugMode(true);
      }
    };
  }
  setIsDebugMode(JSON.parse(localStorage.getItem(BLAZE_DEBUG)));
};
export default setBlazeDebug;
//# sourceMappingURL=set-blaze-debug.js.map